import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function ArrowRightCircleFilledIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...(size !== undefined && { width: size, height: size })}
			{...props}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M12 1.25C6.06294 1.25 1.25 6.06294 1.25 12C1.25 17.9371 6.06294 22.75 12 22.75C17.9371 22.75 22.75 17.9371 22.75 12C22.75 6.06294 17.9371 1.25 12 1.25ZM14.0304 8.96971C13.7375 8.67679 13.2626 8.67676 12.9697 8.96963C12.6768 9.2625 12.6768 9.73737 12.9696 10.0303L14.1892 11.25H8C7.58579 11.25 7.25 11.5858 7.25 12C7.25 12.4142 7.58579 12.75 8 12.75H14.1895L12.9697 13.9696C12.6768 14.2625 12.6768 14.7374 12.9696 15.0303C13.2625 15.3232 13.7374 15.3232 14.0303 15.0304L16.5303 12.5307C16.671 12.3901 16.75 12.1993 16.75 12.0004C16.75 11.8015 16.671 11.6108 16.5304 11.4701L14.0304 8.96971Z"
				fill="currentColor"
			/>
		</svg>
	);
}

ArrowRightCircleFilledIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default ArrowRightCircleFilledIcon;
